import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private kioskSubject = new BehaviorSubject<boolean>(false);
  private meisterSubject = new BehaviorSubject<boolean>(false);
  private selfServiceSubject = new BehaviorSubject<boolean>(false);
  private adminSubject = new BehaviorSubject<boolean>(false);
  private kioskEnrollmentSubject = new BehaviorSubject<boolean>(false);
  private kioskBookingsSubject = new BehaviorSubject<boolean>(false);
  private dataStewardSubject = new BehaviorSubject<boolean>(false);

  // Observables
  kiosk$ = this.kioskSubject.asObservable();
  meister$ = this.meisterSubject.asObservable();
  selfService$ = this.selfServiceSubject.asObservable();
  admin$ = this.adminSubject.asObservable();
  kioskEnrollment$ = this.kioskEnrollmentSubject.asObservable();
  kioskBookings$ = this.kioskBookingsSubject.asObservable();
  dataSteward$ = this.dataStewardSubject.asObservable();

  // Getters
  get isSelfService(): boolean {
    return this.selfServiceSubject.getValue();
  }

  get isKiosk(): boolean {
    return this.kioskSubject.getValue();
  }

  get isMeister(): boolean {
    return this.meisterSubject.getValue();
  }

  get isAdmin(): boolean {
    return this.adminSubject.getValue();
  }

  // NEW getters
  get isSupportEnrollment(): boolean {
    return this.kioskEnrollmentSubject.getValue();
  }

  get isSupportBookings(): boolean {
    return this.kioskBookingsSubject.getValue();
  }

  get isDataSteward(): boolean {
    return this.dataStewardSubject.getValue();
  }

  // Updated method with NEW roles
  updateUserRoles(
    kiosk: boolean,
    meister: boolean,
    selfService: boolean,
    admin: boolean,
    kioskEnrollment: boolean,
    kioskBookings: boolean,
    dataSteward: boolean,
  ): void {
    this.kioskSubject.next(kiosk);
    this.meisterSubject.next(meister);
    this.selfServiceSubject.next(selfService);
    this.adminSubject.next(admin);
    this.kioskEnrollmentSubject.next(kioskEnrollment);
    this.kioskBookingsSubject.next(kioskBookings);
    this.dataStewardSubject.next(dataSteward);
  }
}
